export function getActivityTimingLimits(activity) {
  if (activity?.type !== 'debate' || !activity.segments?.length) return null;
  return Object.fromEntries(['green', 'amber', 'red'].map(field => {
    let total = 0;
    let hasValue = false;
    for (const segment of activity.segments) {
      const value = String(segment[field] || '').trim();
      if (!value) continue;
      const match = value.match(/^(\d+)(?::(\d{1,2}))?$/);
      if (!match || Number(match[2] || 0) >= 60) return [field, ''];
      hasValue = true;
      total += Number(match[1]) * 60 + Number(match[2] || 0);
    }
    return [field, hasValue ? `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}` : ''];
  }));
}
